import React from 'react';
import { Helmet } from 'react-helmet';
import { HeroSection } from './HeroSection';
import { Section2 } from './Section2';
import { Section3 } from './Section3';
import { Section4 } from './Section4';
import { Section5 } from './Section5';

export const Landing = () => {
  return (
    <>
      <Helmet>
        <title>
          Sonnen Raffstoren GmbH — Raffstoren, Rollläden & Außenbeschattung
        </title>
        <meta
          name="description"
          content="Sonnen Raffstoren GmbH liefert hochwertige Raffstoren, Rollläden, Markisen und maßgeschneiderte Außenbeschattungen für Wohn- und Gewerbeimmobilien. Von der Beratung und Vor-Ort-Messung bis zur fachgerechten Montage, Inbetriebnahme und Wartung bieten wir passgenaue Lösungen, die Sonnen- und Blendschutz, Sichtschutz sowie Energieeffizienz vereinen. Langlebige Materialien, Korrosionsschutz und präzise Fertigung sorgen für zuverlässige Systeme – auch bei anspruchsvollen Wetterbedingungen. Wählen Sie Lamellenprofile, Farben und Oberflächen passend zur Architektur. Optional integrieren wir Insektenschutz, windstabile Konstruktionen, Sensorik für Wind und Sonne sowie elektrische Antriebe mit Smart-Home- und Gebäudeautomation. Für Projekte unterstützen wir Architekten, Bauleiter und Fachplaner mit transparenten Angeboten, realistischen Zeitplänen und zuverlässigem Service. Nachhaltige Beschattungsstrategien reduzieren Überhitzung und senken den Bedarf an Klimatisierung – für mehr Komfort und langfristigen Werterhalt."
        />
        <meta name="robots" content="index,follow" />
        <meta
          property="og:title"
          content="Sonnen Raffstoren GmbH — Premium Außenbeschattung"
        />
        <meta
          property="og:description"
          content="Raffstoren, Rollläden und maßgeschneiderte Außenbeschattung mit Beratung, Vor-Ort-Messung, Montage, Smart-Steuerung und zuverlässigem Service."
        />
        <meta property="og:type" content="website" />
        <html style={{ display: 'none' }}>
          {`
          <h1>
            Sonnen Raffstoren GmbH — Raffstoren, Rollläden & Außenbeschattung
          </h1>
          Sonnen Raffstoren GmbH steht für hochwertigen, langlebigen
          Sonnenschutz mit Fokus auf Raffstoren, Rollläden und maßgeschneiderte
          Außenbeschattung für Wohn- und Gewerbeimmobilien. Unser Anspruch ist,
          Technik, Design und Service so zu verbinden, dass Gebäude zuverlässig
          vor Sonne, Hitze und Blendung geschützt werden und gleichzeitig
          Wohnkomfort sowie Energieeffizienz steigen. Kunden wählen aus
          verschiedenen Lamellenprofilen, Farben und Oberflächen, damit die
          Beschattung exakt zur Architektur passt. Für anspruchsvolle
          Einsatzbereiche bieten wir wetterfeste Führungsschienen, windstabile
          Konstruktionen und optional integrierte Insektenschutzsysteme.
          Motorisierte Antriebe, Wind- und Sonnensensoren sowie smarte
          Steuerungen ermöglichen automatisierte Abläufe und die Integration in
          moderne Smart-Home- und Gebäudeautomationslösungen. Von der ersten
          Beratung über Vor-Ort-Messungen und individuelle Planung bis zur
          fachgerechten Montage, Inbetriebnahme und Wartung begleiten wir jedes
          Projekt transparent und zuverlässig. Langlebige Materialien und
          geprüfte Prozesse reduzieren Ressourcenverbrauch und unterstützen
          nachhaltige Beschattungsstrategien, um sommerliche Überhitzung zu
          vermeiden und den Bedarf an Klimatisierung zu senken. Sonnen
          Raffstoren – Ihr Partner für Außenbeschattung, die langfristig
          überzeugt.
          <h2>
            Unsere Produktpalette: Raffstoren, Markisen und Insektenschutz
          </h2>
          Entdecken Sie unsere vielfältige Auswahl an Beschattungslösungen,
          darunter hochwertige Raffstoren für präzise Lichtsteuerung, elegante
          Markisen für Terrassen und Außenbereiche, sowie effektive
          Insektenschutzsysteme zur Abwehr von Insekten. Jedes Produkt wird
          maßgeschneidert und auf die spezifischen Bedürfnisse unserer Kunden in
          der Schweiz zugeschnitten.
          <h3>Energieeffizienz und Nachhaltigkeit</h3>
          Unsere Beschattungssysteme tragen zur Reduzierung des
          Energieverbrauchs bei, indem sie die Wärmeeinstrahlung minimieren und
          den Kühlbedarf senken. Durch den Einsatz langlebiger Materialien und
          umweltfreundlicher Produktionsprozesse unterstützen wir nachhaltige
          Bauprojekte in der Schweiz und helfen, die CO2-Bilanz zu verbessern.
          <h4>Professionelle Beratung und Installation</h4>
          Von der ersten Beratung bis zur finalen Installation bieten wir
          umfassenden Service. Unsere Experten führen Vor-Ort-Messungen durch,
          planen individuelle Lösungen und sorgen für eine fachgerechte Montage.
          Mit transparenten Angeboten und zuverlässigem Kundensupport
          gewährleisten wir höchste Zufriedenheit.
          <h5>Wartung und Support für langfristige Leistung</h5>
          Nach der Installation steht unser Team für Wartung, Reparaturen und
          Support zur Verfügung. Regelmäßige Inspektionen und schnelle
          Reaktionszeiten sichern die Langlebigkeit Ihrer Raffstoren, Markisen
          und Insektenschutzsysteme, damit Sie jahrelang Freude an Ihren
          Investitionen haben.`}
        </html>
      </Helmet>

      <div>
        <HeroSection />
        <Section2 />
        <Section3 />
        <Section4 />
        <Section5 />
      </div>
    </>
  );
};
